export interface ICaseDocument {
  id: number;
  creationDate: Date;
  documentId: string;
  documentType: string;
  documentName: string;
  documentStatus: string;
  documentExtension: string;
  outgoing: boolean;
  sender: string;
  recipient: string;
  caseDocumentTags: ICaseDocumentTag[];
  comments: string;
  unhandled: boolean;
  deleted: boolean;
  deletedBy: string;
  stakeholderSenderId: number;
  stakeholderReceiverId: number;
}

export interface ICaseDocumentTag {
  name: string;
  preTagged?: boolean;
}

export enum CaseDocumentTagEnum {
  MEDICAL_INFO = 'Medical info',
  TRAVEL_INFO = 'Travel info',
  PASSPORT_AND_ID = 'Passport and ID',
  INSURANCE_INFO = 'Insurance info',
  GOP_VOB = 'GOP / VOB',
  GOP_VOB_CANCEL = 'GOP / VOB cancelled',
  CLAIM_FORM = 'Claim form',
  RECEIPT = 'Receipt',
  CONSENT = 'Consent accepted',
  CONSENT_REJECTED = 'Consent rejected',
  MEDIF = 'MEDIF',
  CLAIM_LETTER = 'Claim letter',
  MEDICAL_PRE_ASSESSMENT = 'Medical pre-assessment',
  RECOVERY_DECISION = 'Recovery decision',
  RECOVERY_POA_REQUEST = 'Recovery POA Request',
  RECOVERY_POA_FIRST_REMINDER = 'Recovery POA Request First Reminder',
  RECOVERY_POA_SECOND_REMINDER = 'Recovery POA Request Second Reminder',
  RECOVERY_POA_SIGNED = 'Recovery POA Signed',
  RECOVERY_APPLICATION = 'Recovery Application',
  RECOVERY_NOT_POSSIBLE = 'Recovery not possible',
  INVESTIGATION = 'Investigation report',
  TRANSLATION = 'Translation report',
  SUPPLIER_INVOICE = 'Supplier invoice',
  ESCORT_TRAVEL_EXPENSES = 'Escort travel expenses',
  MEDICAL_ESCORT_INVOICE = 'Medical escort invoice',
  CUSTOMER_INVOICE = 'Customer invoice'
}
